import {
  Component,
  OnInit,
  AfterViewInit,
  OnChanges,
  Input,
  SimpleChanges,
  OnDestroy
} from "@angular/core";
import { TransferEndToEndSlaTrendService } from "./service/transfer-end-to-end-sla-trend.service";
import * as Highcharts from "highcharts";
import addMore from "highcharts/highcharts-more";
import { TranslateService } from "@ngx-translate/core";
import { LocalStorageService } from "../../../../shared/services/local-storage.service";
import { BroadcasterService } from "../../../../core/services/broadcaster.service";
import * as HSET from "./settings";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
addMore(Highcharts);

@Component({
  selector: "widget-transfer-end-to-end-sla-trend",
  templateUrl: "./widget-transfer-end-to-end-sla-trend.component.html",
  styleUrls: ["./widget-transfer-end-to-end-sla-trend.component.scss"],
  providers: [TransferEndToEndSlaTrendService]
})
export class WidgetTransferEndToEndSlaTrendComponent
  implements OnInit, OnChanges, OnDestroy {
  private unsubscribe: Subject<void> = new Subject();
  @Input() FILTERS;
  @Input() OPTIONS;
  widgetId = 7;

  highcharts: typeof Highcharts = Highcharts;
  chartOptions = HSET.chartData;
  errorMessage = "";
  mockChart = null;
  loadingChart = true;

  constructor(
    private translateService: TranslateService,
    private dataService: TransferEndToEndSlaTrendService,
    private broadcaster: BroadcasterService,
    private localStorageService: LocalStorageService
  ) {
    this.chartOptions = HSET.chartData;

  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      JSON.stringify(changes.FILTERS.currentValue) !==
      JSON.stringify(changes.FILTERS.previousValue) &&
      !changes.FILTERS.firstChange
    ) {
      this.getTransferEndToEndSlaTrendData();
    }
  }

  ngOnInit() {
    this.translateService
      .get("PERFORMANCE.TRANSFER.REASON_FOR_FAILURE")
      .pipe(takeUntil(this.unsubscribe)).subscribe(text => {
        this.OPTIONS.title = this.OPTIONS.title || text;
      });
    this.broadcaster.listen("PAGE_WIDGET_DATA")
      .pipe(takeUntil(this.unsubscribe)).subscribe(() => {
        this.setWidgetData();
      });
    this.chartOptions = HSET.chartData;

    this.getTransferEndToEndSlaTrendData();
  }
  setWidgetData() {
    const pageData = this.localStorageService.getItem("PAGE_WIDGET_DATA");
    if (pageData) {
      pageData.forEach(element => {
        if (element.widget_id === this.widgetId) {
          this.setTarget(element.target);
        }
      });
    }
  }

  setTarget(t) {
    if (this.chartOptions) {
      this.chartOptions.series[2].data = [];
      for (let i = 0; i < this.chartOptions.series[0].data.length; i++) {
        this.chartOptions.series[2].data.push(t);
      }
    }
  }

  getTransferEndToEndSlaTrendData() {
    this.loadingChart = true;
    this.errorMessage = "";
    this.mockChart = null;
    this.dataService
      .getTransferEndToEndSlaTrendData(this.OPTIONS.api, this.FILTERS)
      .pipe(takeUntil(this.unsubscribe)).subscribe(
        chartData => {
          if (chartData === null) {
            this.errorMessage = "ERROR_MSG.NO_DATA";
            this.mockChart = HSET.chartData;
            this.loadingChart = true;
          } else {
            this.loadingChart = false;

            this.chartOptions = this.dataService.createChart(
              chartData,
              this.OPTIONS
            );
            this.setWidgetData();
          }
        },
        error => {
          this.errorMessage = "ERROR_MSG.SYSTEM_ERROR";
          this.mockChart = HSET.chartData;
          this.loadingChart = true;
        }
      );
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
